var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var STRING_RELATIONS = [
    { code: 'STR_CONTAINS', dataType: 'STRING_LIKE', arity: 1, symbols: ['~'], negatedCode: 'STR_NOT_CONTAINS' },
    { code: 'STR_STARTS', dataType: 'STRING_LIKE', arity: 1, symbols: [], negatedCode: 'STR_NOT_STARTS' },
    { code: 'STR_EQ', dataType: 'STRING_LIKE', arity: 1, symbols: ['='], negatedCode: 'STR_EXCEPT' },
    { code: 'STR_EXCEPT', dataType: 'STRING_LIKE', arity: 1, symbols: ['!='], negatedCode: 'STR_EQ' },
    { code: 'STR_NOT_STARTS', dataType: 'STRING_LIKE', arity: 1, symbols: [], negatedCode: 'STR_STARTS' },
    { code: 'STR_NOT_CONTAINS', dataType: 'STRING_LIKE', arity: 1, symbols: [], negatedCode: 'STR_CONTAINS' },
    { code: 'STR_BETWEEN', dataType: 'STRING_LIKE', arity: 2, symbols: ['..'] },
    { code: 'STR_FILLED', dataType: 'STRING_LIKE', arity: 0, symbols: [], negatedCode: 'STR_NOT_FILLED' },
    { code: 'STR_NOT_FILLED', dataType: 'STRING_LIKE', arity: 0, symbols: [], negatedCode: 'STR_FILLED' },
    // CZNA-217: no negated counterpart — CZNA negates the whole clause, not the relation.
    { code: 'STR_MATCHES', dataType: 'STRING_LIKE', arity: 1, symbols: [] },
];
var NUMBER_RELATIONS = [
    { code: 'NUM_EQ', dataType: 'NUMBER', arity: 1, symbols: ['='], negatedCode: 'NUM_EXPECT' },
    { code: 'NUM_EXPECT', dataType: 'NUMBER', arity: 1, symbols: ['!='], negatedCode: 'NUM_EQ' },
    { code: 'NUM_GREATER', dataType: 'NUMBER', arity: 1, symbols: ['>', '>='] },
    { code: 'NUM_LESSER', dataType: 'NUMBER', arity: 1, symbols: ['<', '<='] },
    { code: 'NUM_BETWEEN', dataType: 'NUMBER', arity: 2, symbols: ['..'] },
    { code: 'NUM_FILLED', dataType: 'NUMBER', arity: 0, symbols: [], negatedCode: 'NUM_NOT_FILLED' },
    { code: 'NUM_NOT_FILLED', dataType: 'NUMBER', arity: 0, symbols: [], negatedCode: 'NUM_FILLED' },
];
var DATE_RELATIONS = [
    { code: 'DAT_EQ', dataType: 'DATE', arity: 1, symbols: ['='], negatedCode: 'DAT_EXCEPT' },
    { code: 'DAT_EXCEPT', dataType: 'DATE', arity: 1, symbols: ['!='], negatedCode: 'DAT_EQ' },
    { code: 'DAT_GREATER', dataType: 'DATE', arity: 1, symbols: ['>', '>='] },
    { code: 'DAT_LESSER', dataType: 'DATE', arity: 1, symbols: ['<', '<='] },
    { code: 'DAT_BETWEEN', dataType: 'DATE', arity: 2, symbols: ['..'] },
    { code: 'DAT_FILLED', dataType: 'DATE', arity: 0, symbols: [], negatedCode: 'DAT_NOT_FILLED' },
    { code: 'DAT_NOT_FILLED', dataType: 'DATE', arity: 0, symbols: [], negatedCode: 'DAT_FILLED' },
];
var BOOLEAN_RELATIONS = [
    { code: 'BOOL_EQ', dataType: 'BOOLEAN', arity: 1, symbols: ['='] },
];
var ALL_RELATIONS = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], STRING_RELATIONS, true), NUMBER_RELATIONS, true), DATE_RELATIONS, true), BOOLEAN_RELATIONS, true);
var BEHAVIOR_BY_CODE = new Map(ALL_RELATIONS.map(function (behavior) { return [behavior.code, behavior]; }));
/** Behaviour metadata of a relation code. */
export var relationBehavior = function (code) {
    var behavior = BEHAVIOR_BY_CODE.get(code);
    if (!behavior) {
        throw new Error("Unknown relation code: ".concat(code));
    }
    return behavior;
};
/** All relations applicable to a data type, in suggestion order. */
export var relationsForDataType = function (dataType) {
    switch (dataType) {
        case 'STRING':
        case 'TEXT':
            return STRING_RELATIONS.map(function (behavior) { return behavior.code; });
        case 'NUMBER':
            return NUMBER_RELATIONS.map(function (behavior) { return behavior.code; });
        case 'DATE':
            return DATE_RELATIONS.map(function (behavior) { return behavior.code; });
        case 'BOOLEAN':
            return BOOLEAN_RELATIONS.map(function (behavior) { return behavior.code; });
        default:
            // The server data type is nullable/open-ended; an unknown value yields no
            // relations rather than undefined, so callers cannot crash on it.
            return [];
    }
};
/** Default relation of a data type when the server does not specify one. */
export var defaultRelationForDataType = function (dataType) {
    switch (dataType) {
        case 'STRING':
        case 'TEXT':
            return 'STR_CONTAINS';
        case 'NUMBER':
            return 'NUM_EQ';
        case 'DATE':
            return 'DAT_EQ';
        case 'BOOLEAN':
            return 'BOOL_EQ';
        default:
            // Fall back to a string relation for an unknown/absent data type.
            return 'STR_CONTAINS';
    }
};
/** Resolves a symbol shortcut (`=`, `>`, `..`, …) to a relation of the data type. */
export var relationForSymbol = function (symbol, dataType, available) {
    var candidates = relationsForDataType(dataType);
    return candidates.find(function (code) { return available.has(code) && relationBehavior(code).symbols.includes(symbol); });
};
